import styled from "styled-components";
import { colors } from "../../../../../styles/Colors";
import { CardInput, SimulationAmount } from "../../../../CardInputs/CardsStyledComponents";
import { TextMedium } from "../../../../../styles/GlobalStyledComponents";


export const CardValues = styled.div``;
interface CardSectionProps {
  canHide?: boolean;
}
export const CardSection = styled.div<CardSectionProps>`
    display: flex;
    padding: 10px 0px;
    align-items: center;
    @media (max-width: 500px) {
      display: ${props => props.canHide ? 'none' : 'flex'};
    }
`;
export const CardPaymentPlan = styled(CardSection)`
  position: relative;
  align-items: baseline;
  display: block;
  width: 100%;
  gap: 10px;
  padding: 10px 24px 24px 24px;
  background-color: ${(props) => props.theme.colors.gray12};
  border-radius: 0 0 16px 16px;

  @media (max-width: 650px) {
    padding: 15px;
  }
`;

export const SelectDaysPayment = styled.select`
  min-width: 160px;
  max-width: 200px;
  height: 48px;
  padding: 12px;
  margin-right: 10px;
  font-size: 16px;
  line-height: 22px;
  border-radius: 4px;
  border: solid 1px ${(props) => props.theme.colors.gray6};
  color: ${(props) => props.theme.colors.gray0};
  background-color: ${(props) => props.theme.colors.white};

  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &:focus-visible {
    outline: 1px solid ${(props) => props.theme.colors.gray9};
  }

  @media (max-width: 650px) {
    max-width: 100%;
  }

  @media (max-width: 320px) {
    width: 160px;
  }
`;


export const CardPaymentRow = styled(CardInput)`
  flex-direction: row;
  border-radius: 8px;
`;
export const CardMiddle = styled.div`
place-content: end; 

`;
export const SectionCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const SectionCardSelect = styled.div`
  display: flex;
  align-items: center;
`;

export const CardInputCustomPayment = styled(CardInput)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0;
`;

export const Circle = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${(props) => props.theme.colors.red6};
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  color: ${(props) => props.theme.colors.white};
  font-size: 12px;
`;

export const CardCustomPaymentSection = styled(CardSection)`
  gap: 10px;
  padding: 24px 24px 8px;

  @media (max-width: 650px) {
    padding: 15px;
  }
`;

export const SimulationTerm = styled(SimulationAmount)`
  @media (max-width: 420px) {
    font-size: 14px;
  }
`;

export const SimulationRange = styled.input`
  /* === range theme and appearance === */
  font-size: 1.5rem;
  width: 100%;
  color: ${colors.red6};
  --thumb-height: 0.875em;
  --track-height: 0.175em;
  --track-color: rgba(0, 0, 0, 0.2);
  --brightness-hover: 180%;
  --brightness-down: 80%;
  --clip-edges: 0.125em;

  /* === range commons === */
  position: relative;
  background: #fff0;
  overflow: hidden;
  -webkit-appearance: none;
  transition: all ease 100ms;
  height: var(--thumb-height);

  /* === WebKit specific styles === */
  /* &, */
  &::-webkit-slider-runnable-track,
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    transition: all ease 100ms;
    height: var(--thumb-height);
  }

  &::-webkit-slider-runnable-track,
  &::-webkit-slider-thumb {
    position: relative;
  }

  &::-webkit-slider-thumb {
    border-radius: 50%;
    --thumb-radius: calc((var(--thumb-height) * 0.5) - 1px);
    --clip-top: calc((var(--thumb-height) - var(--track-height)) * 0.5 - 0.5px);
    --clip-bottom: calc(var(--thumb-height) - var(--clip-top));
    --clip-further: calc(100% + 1px);
    --box-fill: calc(-100vmax - var(--thumb-width, var(--thumb-height))) 0 0
      100vmax currentColor;

    width: var(--thumb-width, var(--thumb-height));
    background: linear-gradient(currentColor 0 0) scroll no-repeat left center /
      50% calc(var(--track-height) + 1px);
    background-color: currentColor;
    box-shadow: var(--box-fill);
    border-radius: var(--thumb-width, var(--thumb-height));
    border: solid 2px white;

    filter: brightness(100%);
    clip-path: polygon(
      100% -1px,
      var(--clip-edges) -1px,
      0 var(--clip-top),
      -100vmax var(--clip-top),
      -100vmax var(--clip-bottom),
      0 var(--clip-bottom),
      var(--clip-edges) 100%,
      var(--clip-further) var(--clip-further)
    );
  }

  &:hover::-webkit-slider-thumb {
    filter: brightness(var(--brightness-hover));
    cursor: grab;
  }

  &:active::-webkit-slider-thumb {
    filter: brightness(var(--brightness-down));
    /* cursor: grabbing; */
  }

  &::-webkit-slider-runnable-track {
    background: linear-gradient(var(--track-color) 0 0) scroll no-repeat center /
      100% calc(var(--track-height) + 1px);
  }

  &:disabled::-webkit-slider-thumb {
    cursor: not-allowed;
  }

  /* === Firefox specific styles === */
  &,
  &::-moz-range-track,
  &::-moz-range-thumb {
    appearance: none;
    transition: all ease 100ms;
    height: var(--thumb-height);
  }

  &::-moz-range-track,
  &::-moz-range-progress {
    background: #fff0;
  }

  &::-moz-range-thumb {
    background: currentColor;
    width: var(--thumb-width, var(--thumb-height));
    border: 2px solid #fff;
    border-radius: var(--thumb-width, var(--thumb-height));
    cursor: grab;
  }

  &:active::-moz-range-thumb {
    cursor: grabbing;
  }

  &::-moz-range-track {
    width: 100%;
    background: var(--track-color);
  }

  &::-moz-range-progress {
    appearance: none;
    background: currentColor;
    transition-delay: 30ms;
  }

  &::-moz-range-track,
  &::-moz-range-progress {
    height: calc(var(--track-height) + 1px);
    border-radius: var(--track-height);
  }

  &::-moz-range-thumb,
  &::-moz-range-progress {
    filter: brightness(100%);
  }

  &:hover::-moz-range-thumb,
  &:hover::-moz-range-progress {
    filter: brightness(var(--brightness-hover));
  }

  &:active::-moz-range-thumb,
  &:active::-moz-range-progress {
    filter: brightness(var(--brightness-down));
  }

  &:disabled::-moz-range-thumb {
    cursor: not-allowed;
  }
`;

export const SelectSelectWrapper = styled.span`
  position: relative;
`;

export const CardBackground = styled(CardInput)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 20px;
  margin-top: 16px;
`;

export const LineSeparator = styled.div`
  width: 100%;
  height: 2px;
  background-color: ${(props) => props.theme.colors.gray11};
  margin: 10px 0;
`;

export const WarningWrapper = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
`;

export const WarningWrapperPlan = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  margin-top: 15px;
`;

export const WrapperTextInfo = styled.div`
  margin-top: 5px;
`;

export const QuantityTextInfo = styled(TextMedium)`
  white-space: nowrap;
`;

export const DescriptionText = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  padding-left: 8px;
`;